import { ButtonHTMLAttributes } from "react";

interface TrashEmptyButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

const TrashEmptyButton = ({ children, ...props }: TrashEmptyButtonProps) => {
  return (
    <button
      {...props}
      className="rounded-[5px] px-[8px] py-[3px] text-[12px] leading-[150%] text-80 hover:bg-w-8-hover hover:text-white"
    >
      {children}
    </button>
  );
};

export default TrashEmptyButton;
